<div *ngIf="paynescoreData && berkusData && riskSummation && discountedCashFlow && ventureCapital && earningMultiplier; else msg">
    <table class="table table-fixed  table-striped table-bordered table-hover" >
        <thead>
          <tr>
            <th scope="col">Method</th>
            <th scope="col">M$</th>
          </tr>
        </thead>
        <tbody class="table-group-divider">
          <tr *ngFor="let row of rows; let i = index">
            <th scope="row">{{ row.parameter }}</th>
            <td>
              <input
                type="number"
                [(ngModel)]="row.ms"
                placeholder="Enter value"
              />
            </td>
        
          </tr>
        </tbody>

        <tfoot>
            <tr>
              <th colspan="1">Company valuation</th>
              <td>{{ calculateMS() | number: '1.2-2' }}</td>
            </tr>
        </tfoot>
      </table>
</div>

<ng-template #msg>
     <div class="d-flex justify-content-center align-items-center">
      Please fill all forms data to get report 
     </div>
</ng-template>



